var $ = jQuery;

function initHeroSwiper() {
    $('body').find('.main-hero-swiper').each(function () {
        var el = $(this),
            id = el.attr('id');

        new Swiper('#' + id, {
            effect: 'fade',
            loop: true,
            speed: 500,
            autoplay: {
                delay: 8000
            },
            simulateTouch: false
        });
    });
}

function initTextMediaSwiper() {
    $('body').find('.text-media-swiper').each(function () {
        var el = $(this),
            id = el.attr('id');

        new Swiper('#' + id, {
            slidesPerView: 1,
            loop: true,
            speed: 600,
            autoHeight: true,
            navigation: {
                nextEl: '#' + id + ' .swiper-button-next',
                prevEl: '#' + id + ' .swiper-button-prev'
            }
        });
    });

}

function initFeturedContentSwiper() {
    $('body').find('.featured-list .swiper-container').each(function () {
        var el = $(this),
            id = el.attr('id'),
            parentId = el.parent().attr('id');

        new Swiper('#' + id, {
            slidesPerView: "auto",
            loop: true,
            speed: 600,
            loopAdditionalSlides: 6,
            navigation: {
                nextEl: '#' + parentId + ' .swiper-button-next',
                prevEl: '#' + parentId + ' .swiper-button-prev'
            }
        });
    });

}

$(function () {
    initHeroSwiper();
    initTextMediaSwiper();
    initFeturedContentSwiper();
});